<template>
    <div class="mb-4 bg-white rounded-lg p-[16px] w-full overflow-hidden">
            <h2 class="text-4xl text-[#2b2b2b]">Payroll</h2>

            <div class="my-6 flex items-center justify-between">
                <div class="w-[250px] flex flex-col items-start ">
                    <div class="h-[35px] text-black font-light cursor-pointer w-full rounded-xl border outline-none p-3 focus:outline-none">
                        <span>Période : {{ convertirDate(periode) }}</span>
                    </div>
                </div>
                <div class="flex items-center justify-end gap-x-3">
                    <div class="inline-block relative">
                        <button v-on:click="show = true" class="rounded-xl px-8 h-[35px] border font-light text-white bg-[#3c41e9] flex items-center gap-x-2 relative"><ArrowUpFromLine :size="18" strokeWidth="1.2"/> Générer</button>
                        <Transition
                            name="popup-animation"
                            @before-enter="beforeEnter"
                            @enter="enter"
                            @leave="leave"
                            >
                            <div v-if="show" id="generator" class="absolute w-[300px] text-black rounded-lg p-6 top-[110%] shadow-lg border right-0 bg-white">
                                <div class="flex justify-between items-center">
                                    <h3 class="font-extralight">Choisir le mois</h3>
                                    <X color="#000" strokeWidth="1.2" :size="18" class="cursor-pointer" v-on:click="show = false"/>
                                </div>
                                <div class="flex flex-col gap-y-3 mt-4">
                                    <input type="month" v-model="month" class="w-full h-[40px] rounded-lg border cursor-pointer px-5">
                                    <button v-on:click="getData" :disabled="asSend" class="w-full rounded-lg text-white h-[40px] bg-[#3c41e9] font-light">
                                        <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                                        <span v-if="!asSend">Charger</span>
                                    </button>
                                </div>
                            </div>
                        </Transition>
                    </div>
                <button class="rounded-xl px-8 h-[35px] border font-light text-black flex items-center gap-x-2"><FolderUp :size="18" strokeWidth="1.2"/> Exporter</button>
                </div>
            </div>

            <div class="p-2 flex items-center gap-x-2 rounded-lg bg-[#eef1fb] border border-[#d1dbe8] text-[12px] font-extralight text-black">
                <Info :size="15" strokeWidth="1.6" fill="#3772f5" color="#fff"/> Pour afficher l'historique de paiement sur une période donné vous devez cliqué sur le bouton <span class="underline cursor-pointer" v-on:click="show = true">"Générer"</span> ci-dessus
            </div>

            <div class="my-6 grid grid-cols-4 gap-x-6">
                <div v-for="(value,idx) in data" :key="idx" class="rounded-xl border w-full text-black">
                    <div class="p-6">
                        <h3 class="font-extralight text-white">{{ value.libelle }}</h3>
                    </div>
                    <div class="p-6 bg-[#f5f8fa]">
                        <span class="text-[20px] text-[#f5f8fa]">{{ value.price }} Fcfa</span>
                    </div>
                </div>
            </div>

            <div class="w-full mb-6 rounded-lg border text-black">
                <div class="p-6 flex items-center justify-between">
                    <h2 class="font-extralight text-white">Total Payrolls</h2>
                </div>
                <div class="p-6 bg-[#f5f8fa]">
                    <div class="flex justify-start items-center gap-x-5 mb-5">
                        <div class="flex items-center gap-x-2">
                            <div  class="size-5 rounded-md bg-[#3474f4]"/>
                            <span class="font-extralight text-[#f5f8fa]">Payroll</span>
                        </div>
                        <div class="flex items-center  gap-x-2">
                            <div  class="size-5 rounded-md bg-[#fa9832]"/>
                            <span class="font-extralight text-[#f5f8fa]">Overtime</span>
                        </div>
                        <div class="flex items-center gap-x-2">
                            <div class="size-5 rounded-md bg-[#24ae75]"/>
                            <span class="font-extralight text-[#f5f8fa]">Bonus</span>
                        </div>
                    </div>
                    <div id="chart" class="w-full"></div>
                </div>
            </div>

            <div class="rounded-lg p-4 mb-3 border">
                <div class="flex items-center gap-x-2 text-black font-light rounded-md">
                    <span v-bind:class="getActiveClass('Historique')" v-on:click="selectBar('Historique')">Historique</span>
                    <span v-bind:class="getActiveClass('Livre de paie')" v-on:click="selectBar('Livre de paie')">Livre de paie </span>
                </div>
            </div>

            <div v-if="getActiveTab('Historique')" class="w-full">
                <div class="border rounded-lg">
                        <div class="body">
                            <template v-if="!load">
                                <div class="text-black p-6 flex items-center justify-between">
                                    <h2 class="font-extralight text-[18px]">Historique</h2>

                                    <button :disabled="loadedData.length == 0" class="rounded-xl px-8 h-[35px] border font-light bg-black text-white flex items-center gap-x-2">
                                        <Send :size="16" strokeWidth="1.2"/> Envoyer en masse
                                    </button>
                                </div>
                                <template v-if="loadedData.length != 0">
                                    <table class="w-full rounded-b-lg text-black border-none table-hover js-exportable tableExceptionClassement">
                                        <thead>
                                            <tr class="bg-[#e9edf1] h-[55px]">
                                                <th class="font-extralight pl-3">Id</th>
                                                <th class="font-extralight">Nom employé</th>
                                                <th class="font-extralight">Salaire base</th>
                                                <th class="font-extralight">Sursalaire</th>
                                                <th class="font-extralight">Gratification</th>
                                                <th class="font-extralight">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="dt in loadedData" :key="dt.matricule" class="bg-[#f5f8fa] h-[65px] border-b border-b-[#eaedef]">
                                                <th class="font-extralight pl-3">{{ dt.matricule }}</th>
                                                <th class="font-extralight">{{ dt.nom_prenom }}</th>
                                                <th class="font-extralight">{{ dt.salaire_de_base }}</th>
                                                <th class="font-extralight">{{ dt.sursalaire }}</th>
                                                <th class="font-extralight">{{ dt.gratification }}</th>
                                                <th class="font-extralight">
                                                    <loadDocument :data="dt"/>
                                                </th>
                                            </tr>
                                        </tbody>
                                    </table>
                                </template>
                                <div v-else class="w-full h-[20vh] flex items-center justify-center">
                                    <div class="flex flex-col items-center gap-y-2 text-black">
                                        <Ban strokeWidth="1.2" :size="26"/>
                                        <span class="font-extralight">Aucune donné pour <span class="underline">{{ convertirDate(periode) }}</span></span>
                                    </div>
                            </div>
                            </template>
                            <template v-else>
                                <div class="text-black w-full h-[20vh] flex items-center justify-center">
                                    <span class="font-extralight">Chargement...</span>
                                </div>
                            </template>
                        </div>
                </div>
            </div>

            <div v-if="getActiveTab('Livre de paie')" class="w-full">
                <div class="border rounded-lg w-full">
                        <div class="body w-full">
                            <template v-if="!load">
                                <div class="text-black p-6 flex items-center justify-between">
                                    <h2 class="font-extralight text-[18px]">Livre de paie</h2>

                                    <button v-on:click="generateExcelFile" :disabled="loadedData.length == 0" class="rounded-xl px-8 h-[35px] border font-light bg-black text-white flex items-center gap-x-2">
                                        <BookText :size="16" strokeWidth="1.2" v-if="!loadGetPaylist"/> <Loader2 v-else :size="16" strokeWidth="1.2" class="animate-spin mx-auto"/>Obtenir le livre de paie
                                    </button>
                                </div>
                                <template v-if="loadedData.length != 0">
                                    <div class="overflow-x-auto">
                                        <table class=" w-full rounded-b-lg text-black border-none table-hover">
                                        <thead>
                                            <tr class="bg-[#e9edf1] h-[55px]">
                                                <th class="font-extralight px-8 text-center">Mat</th>
                                                <th class="font-extralight px-8 text-center w-[150px]">Nom & Prénoms</th>
                                                <th class="font-extralight px-8 text-center w-[150px]">Salaire de base ou catégoriel</th>
                                                <th class="font-extralight px-8 text-center w-[150px]">Sursalaire</th>
                                                <th class="font-extralight px-8 text-center w-[100px]">Déduction</th>
                                                <th class="font-extralight px-8 text-center w-[150px]">Prime <br>d'anciennette</th>
                                                <th class="font-extralight px-8 text-center w-[100px]">Heures Suppl <br>Remu</th>

                                                <th class="font-extralight px-8 text-center w-[100px]">Congés</th>
                                                <th class="font-extralight px-8 text-center w-[170px]">Prim., indem. <br>et gratif. <br>imposables</th>
                                                <th class="font-extralight px-8 text-center w-[150px]">Brut <br>imposable</th>
                                                <th class="font-extralight px-8 text-center w-[170px]">Primes <br>et indem. <br>nom impos.</th>
                                                <th class="font-extralight px-8 text-center w-[150px]">ITS</th>
                                                <th class="font-extralight px-8 text-center w-[150px]">Caisse <br>de <br>retraite</th>
                                                <th class="font-extralight px-8 text-center w-[150px]">CMU</th>
                                                <th class="font-extralight px-8 text-center w-[180px]">Avance, <br> acpte, autres <br>retenues</th>
                                                <th class="font-extralight px-8 text-center w-[200px]">Net à payer</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="dt in loadedData" :key="dt.matricule" class="bg-[#f5f8fa] h-[65px] border-b border-b-[#eaedef]">
                                                <th class="font-extralight pl-3">{{ dt.matricule }}</th>
                                                <th class="font-extralight pl-3">{{ dt.salaire_de_base }}</th>
                                                <th class="font-extralight pl-3">{{ dt.sursalaire }}</th>
                                                <th class="font-extralight pl-3">{{ dt.deduction_sur_salaire }}</th>
                                                <th class="font-extralight pl-3">{{ dt.prime_anciennete }}</th>
                                                <th class="font-extralight pl-3">{{ dt.heures_suppl_remur }}</th>
                                                <th class="font-extralight pl-3">{{ dt.conges_payes_gains }}</th>
                                                <th class="font-extralight pl-3">{{ 0.0 }}</th>
                                                <th class="font-extralight pl-3">{{ dt.total_salaire_brut_imposable }}</th>
                                                <th class="font-extralight pl-3">{{ dt.prime_transport_non_impos }}</th>
                                                <th class="font-extralight pl-3">{{ dt.retenue_its }}</th>
                                                <th class="font-extralight pl-3">{{ dt.conges_payes_gains }}</th>
                                                <th class="font-extralight pl-3">{{ dt.retenue_cmu_employe }}</th>
                                                <th class="font-extralight pl-3">{{ dt.avance_sur_salaire }}</th>
                                                <th class="font-extralight pl-3">{{ dt.cmu_employeur }}</th>
                                                <th class="font-extralight pl-3">{{ dt.total_gross_earnings }}</th>
                                            </tr>
                                        </tbody>
                                        </table>
                                    </div>
                                    
                                </template>
                                <div v-else class="w-full h-[20vh] flex items-center justify-center">
                                    <div class="flex flex-col items-center gap-y-2 text-black">
                                        <Ban strokeWidth="1.2" :size="26"/>
                                        <span class="font-extralight">Aucune donné pour <span class="underline">{{ convertirDate(periode) }}</span></span>
                                    </div>
                            </div>
                            </template>
                            <template v-else>
                                <div class="text-black w-full h-[20vh] flex items-center justify-center">
                                    <span class="font-extralight">Chargement...</span>
                                </div>
                            </template>
                        </div>
                </div>
            </div>
    </div>
</template>
<script>
import loadDocument from "@/components/create/load-document.vue";
import {
    Loader2,Send,BookText,
    FolderUp,Info,ArrowUpFromLine,X,Ban} from "lucide-vue-next"
import ApexCharts from "apexcharts"
import gsap from "gsap";
import API from "@/service/API.js";
import toast from "@/components/ui/toast";
import * as XLSX from 'xlsx';
export default {
    name: "PayrollView",
    components:{
        Loader2,
        Send,BookText,
        loadDocument,
        ArrowUpFromLine,X,Ban,
        FolderUp,Info},
    data(){
        return {
            load:true,
            show: false,
            loadedData:[],
            loadGetPaylist:false,
            data: [
                {libelle:"Coût des salaires",price:1600000},
                {libelle:"Dépenses totales",price:270000},
                {libelle:"Paiements en attente",price:25000},
                {libelle:"Total des salaires",price:190000}
            ],
            periode:"",
            month:null,
            asSend: false,
            active: "Historique",
            options:{
                chart: {
                    type: 'bar',
                    height: '300px',
                    stacked: true,
                    animations: {
                        enabled: false
                    },
                    toolbar: {  
                    show: false
                    },
                },
            colors: ['#24ae75', '#fa9832','#3474f4'],
            xaxis: {
                categories: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin','Juil', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'],
                labels: {
                    style: {
                            fontWeight: 200,
                            colors: ['#000000']
                        },
                }
            },
            dataLabels: {
                    enabled: false
                    },
                    legend:{
                        show:false
                },
            series: [
                    { name: 'Bonus', data: [44000, 55000, 41000,44000, 55000, 41000,44000, 55000, 41000,44000, 55000, 41000] },
                    { name: 'Overtime', data: [48000, 50000, 40000,44000, 55000, 41000,44000, 55000, 41000,44000, 55000, 41000] },
                    { name: 'Payroll', data: [13000, 36000, 20000,44000, 55000, 41000,44000, 55000, 41000,44000, 55000, 41000] },
                ]
            }
        }
    },
    
    mounted(){
        this.initChart();
        this.reloadDataList(this.periode);
    },
    created(){
        this.periode = this.obtenirDateActuelleFormatAAAA_MM();
    },
    methods:{
        getActiveTab(libelle){
            return this.active == libelle
        },
        getActiveClass(libelle){
            return `px-4 py-3 rounded-md cursor-pointer ${libelle == this.active ? "bg-[#5357eb] text-white" : "bg-[#f9fafb] text-black"}`;
        },
        selectBar(libelle){
            this.active = libelle;
        },
        initChart(){
            var chart = new ApexCharts(document.querySelector("#chart"), this.options);
            chart.render();
        },
        getData(){
            if(!this.month){
                toast.error("Erreur","Veuillez choisir le mois",4000);
            }
            this.asSend = true;
            API.post("payroll/payslips",{"month": this.month,"include_overtime": true})
            .then((res)=>{
                if(res.status == 200){
                    toast.success("Succès","Donnée mise à jour",4000);
                    this.periode = this.month
                    this.reloadDataList(this.month);
                }
            })
            .catch(()=>{toast.error("Erreur","Il semble avoir une erreur sur le serveur",5000)})
            .finally(()=> this.asSend = false);
        },
        reloadDataList(month){
            this.load = true;
            API.post("payroll/book",{month})
            .then((res)=>{
                if(res.status == 200){
                    this.loadedData = res.data.entries;
                    toast.success("Succès","Les données on été actualiser",3000);
                }
            })
            .catch(()=>{toast.error("Erreur","",5000)})
            .finally(()=>this.load = false);
        },
        convertirDate(dateString) {
            const [annee, mois] = dateString.split('-');
            const nomsMois = [
                "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
                "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
            ];
            const nomMois = nomsMois[parseInt(mois, 10) - 1];
            return `${nomMois} ${annee}`;
            },
        obtenirDateActuelleFormatAAAA_MM() {
            const date = new Date();
            const annee = date.getFullYear();
            const mois = ('0' + (date.getMonth() + 1)).slice(-2);
            return `${annee}-${mois}`;
        },
        beforeEnter(el){
            gsap.set(el, {
                opacity: 0,
                y: 10,
            });
        },
        enter(el, done){
            gsap.to(el, {
                opacity: 1,
                y: 0,
                duration: 0.15,
                ease: "back.out(1.7)",
                onComplete: done,
            });
        },
        leave(el, done){
            gsap.to(el, {
                opacity: 0,
                y: 10,
                duration: 0.15,
                ease: "power2.in",
                onComplete: done,
            });
        },
        generateExcelFile(){
            try{
                this.loadGetPaylist = true;
                const data = [];
                for (const dt of this.loadedData) {
                    data.push({
                        "Mat":dt.matricule,
                        'Nom & Prénoms':dt.salaire_de_base,
                        'Salaire de base ou catégoriel':dt.sursalaire,
                        'Sursalaire':dt.deduction_sur_salaire,
                        'Déduction':dt.prime_anciennete,
                        "Prime d'anciennette":dt.heures_suppl_remur,
                        "Heures Suppl Remu":dt.conges_payes_gains,
                        "Congés":0.0,
                        "Prim., indem. et gratif. imposables":dt.total_salaire_brut_imposable,
                        "Brut imposable":dt.prime_transport_non_impos,
                        "Primes et indem. nom impos.":dt.retenue_its,
                        "ITS":dt.conges_payes_gains,
                        "Caisse de retraite":dt.retenue_cmu_employe,
                        "CMU":dt.avance_sur_salaire,
                        "Avance, acpte, autres retenues":dt.cmu_employeur,
                        "Net à payer":dt.total_gross_earnings
                    })
                }
            

                const worksheet = XLSX.utils.json_to_sheet(data);
                const headerStyle = {
                    font: { bold: true, sz: 14, color: { rgb: "FF000000" } },
                    fill: { fgColor: { rgb: "FFC0C0C0" } },
                    alignment: { horizontal: "center", vertical: "center" }
                };

                const footerData = [{
                        "Mat":"Total",
                        'Nom & Prénoms':"",
                        'Salaire de base ou catégoriel':"",
                        'Sursalaire':"",
                        'Déduction':"",
                        "Prime d'anciennette":"",
                        "Heures Suppl Remu":"",
                        "Congés":"",
                        "Prim., indem. et gratif. imposables":"",
                        "Brut imposable":"",
                        "Primes et indem. nom impos.":"",
                        "ITS":"",
                        "Caisse de retraite":"",
                        "CMU":"",
                        "Avance, acpte, autres retenues":"",
                        "Net à payer":""
                    }];

                // Récupérer les en-têtes de colonnes
                const headers = Object.keys(data[0]);

                // --- Personnalisation de l'en-tête (ligne 1) ---
                headers.forEach((header, index) => {
                    const cellRef = XLSX.utils.encode_cell({ c: index, r: 0 });
                    if (worksheet[cellRef]) {
                    worksheet[cellRef].s = headerStyle;
                    }
                });

                const columnWidths = headers.map(()=> ({ wch: 30 }));
                worksheet['!cols'] = columnWidths;

                // // --- Alternance des couleurs pour les lignes de données ---
                const whiteStyle = { fill: { fgColor: { rgb: "FFFFFFFF" } } };
                const greyStyle = { fill: { fgColor: { rgb: "FFC0C0C0" } } };
                for (let i = 0; i < data.length; i++) {
                    const style = (i % 2 === 0) ? whiteStyle : greyStyle;
                    const row = data[i];
                    Object.keys(row).forEach((key, colIndex) => {
                        const cellRef = XLSX.utils.encode_cell({ c: colIndex, r: i + 1 });
                        if (worksheet[cellRef]) {
                            worksheet[cellRef].s = style;
                        }
                    });
                }
                console.log("log 1")
                // // Ajouter la ligne du footer en bas de la feuille
                XLSX.utils.sheet_add_json(worksheet, footerData, { origin: -1, skipHeader: true });

                const footerRowIndex = data.length + 1;
                // const footerStyle = {
                //     font: { bold: true, color: { rgb: "FF000000" } },
                //     fill: { fgColor: { rgb: "FF969696" } },
                //     alignment: { horizontal: "center" }
                // };

                // Appliquer le style à toutes les cellules de la dernière ligne
                // const footerCells = XLSX.utils.encode_range({ s: { c: 0, r: footerRowIndex }, e: { c: headers.length - 1, r: footerRowIndex } });
                // console.log("voir decode range ====>",XLSX.utils.decode_range(footerCells))
                // console.log("footer cell ===> ",footerCells);
                // XLSX.utils.decode_range(footerCells).forEach(cell => {
                //     const cellRef = XLSX.utils.encode_cell(cell);
                //     if (worksheet[cellRef]) {
                //     worksheet[cellRef].s = footerStyle;
                //     }
                // });
                console.log("log 2")
                // // Fusionner les deux premières cellules du footer
                worksheet['!merges'] = [{
                    s: { r: footerRowIndex, c: 0 },
                    e: { r: footerRowIndex, c: 1 }
                }];

                // Créer un classeur et ajouter la feuille
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Bulletin_de_paie_'+this.month);
                this.loadGetPaylist = false;
            }catch(e){
                console.log(e)
            }
            // Générer le fichier binaire
            // const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

            // Créer un Blob et le sauvegarder via file-saver
            // const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });
            // saveAs(dataBlob, 'rapport_employes.xlsx');
        }
    }
}
</script>